import _typeof from "@babel/runtime/helpers/typeof";
import { isClientFetchError } from './is-client-fetch-error';
var commonErrors = {
  MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
  OPERATION_ABORTED: 'The operation was aborted. ',
  CANCELLED: 'cancelled',
  UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
  NETWORK_CONNECTION_LOST: 'The network connection was lost.',
  TIMEOUT: 'The request timed out.',
  AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
  GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
export var DATA_CLASSIFICATION_NO_ACCESS = 'DATA_CLASSIFICATION_NO_ACCESS';
export var FAILED_TO_FETCH = 'FAILED_TO_FETCH';
export var AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
export var RATE_LIMITING = 'RATE_LIMITING';
export var INVOKE_VALUE_FUNCTION_FAILED = 'Invoke value functions failed:';
export var AGG_UNDERLYING_SERVICE_TIMEOUT = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
export var userConsentErrorRegex = new RegExp('The user did not consent to use the app', 'i');
var BAD_REQUEST = 400;
var REQUEST_TIMEOUT = 408;
export var isChunkLoadError = function isChunkLoadError(error) {
  // React loosely lazy chunk load error type
  if (_typeof(error) === 'object' && error.name === 'ChunkLoadError') {
    return true;
  }

  // Other chunk load error types
  // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
  var KNOWN_NETWORK_ERRORS = ['Failed to fetch dynamically imported module', 'error loading dynamically imported module', 'Importing a module script failed', 'Cannot find module'];
  var isClientFetchErrorMessage = function isClientFetchErrorMessage(message) {
    return Boolean(message) && !!KNOWN_NETWORK_ERRORS.find(function (networkErrorMessage) {
      return (
        // Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage)
      );
    });
  };
  return Boolean(error) && _typeof(error) === 'object' && (isClientFetchErrorMessage(error.message) || _typeof(error.cause) === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
export var getErrorType = function getErrorType(_error) {
  if (_error == null) {
    return 'NULL_OR_UNDEFINED';
  }

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  var error = _error;
  var message = String(error instanceof Error ? error.message : error).trim();
  var isTimeoutError = function isTimeoutError(timedOutResource) {
    var _error$stack;
    return Boolean(_typeof(error) === 'object' && error.name === 'TimeoutError' && ((_error$stack = error.stack) === null || _error$stack === void 0 ? void 0 : _error$stack.includes(timedOutResource)));
  };
  if (message === "A hidden extension shouldn't be rendered") {
    return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
  }
  var circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
  if (circuitBreakerErrorRegex.test(message)) {
    return 'CIRCUIT_BREAKER_ERROR';
  }
  var rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
  var rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
  if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) {
    return RATE_LIMITING;
  }
  var serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
  if (serverErrorRegex.test(message)) {
    var match = message.match(serverErrorRegex);
    var statusCode = match ? match[1] : 'NO_STATUS_CODE';
    return "ERROR_SERVER_RESPONSE_".concat(statusCode);
  }
  var aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
  if (aggGiraServerErrorRegex.test(message)) {
    var _match$;
    var _match = message.match(aggGiraServerErrorRegex);
    var _statusCode = (_match$ = _match === null || _match === void 0 ? void 0 : _match[1]) !== null && _match$ !== void 0 ? _match$ : 'NO_STATUS_CODE';
    return "AGG_GIRA_ERROR_".concat(_statusCode);
  }
  var dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
  var dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
  if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) {
    return DATA_CLASSIFICATION_NO_ACCESS;
  }

  // Add here errors related to a broken app configuration/manifest
  if (message.startsWith('Function definition is invalid.')) {
    return 'APP_DEV_ERROR';
  }
  var graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
  if (graphqlErrorRegex.test(message)) {
    return 'GRAPHQL_ERROR';
  }
  if (userConsentErrorRegex.test(message)) {
    return 'USER_DIDNT_CONSENT_ERROR';
  }
  var aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
  if (aggUnderlyingServiceTimeoutRegex.test(message)) {
    return AGG_UNDERLYING_SERVICE_TIMEOUT;
  }
  var appValueFunction = new RegExp("The app's value function failed", 'i');
  var serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
  var invokeValueFunctionFailed = new RegExp(INVOKE_VALUE_FUNCTION_FAILED, 'i');

  /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */
  var valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === BAD_REQUEST;

  /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */

  var valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === REQUEST_TIMEOUT;
  if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) {
    return 'VALUE_FUNCTION_APP_ERROR';
  }

  /*
   * 	Whole message:
   *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
   */
  var valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
  /*
   * 	Whole message:
   *	Invoke value functions failed: Error server response: 429
   */
  var valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
  if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) {
    return RATE_LIMITING;
  }

  // The full message states:
  // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
  var extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
  if (extensionDoesntExistRegex.test(message)) {
    return 'EXTENSION_DOESNT_EXIST';
  }

  // In case of React error message:
  // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
  var removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
  if (removeChildOnNodeRegex.test(message)) {
    return 'REMOVE_CHILD_ERROR';
  }
  if (isChunkLoadError(error)) {
    return 'CHUNK_LOAD';
  }
  if (isTimeoutError('FORGE_PROJECT_MODULE')) {
    return 'TIMEOUT_PROJECT_MODULE';
  }
  if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) {
    return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
  }
  if (isTimeoutError('PROJECT_CONTEXT')) {
    return 'TIMEOUT_PROJECT_CONTEXT';
  }
  var entry = Object.entries(commonErrors).find(function (arrayItem) {
    return String(arrayItem[1]).toLowerCase() === message.toLowerCase();
  });
  if (entry) {
    return entry[0];
  }
  if (isClientFetchError(error)) {
    return FAILED_TO_FETCH;
  }
  if (error != null && 'statusCode' in error && error.statusCode === 429) {
    return 'RATE_LIMITING';
  }
  return 'OTHER';
};